import React, { useEffect, useState } from 'react'
import Modal from '../../components/UI/Modal'
import { getApiErrorMessage, grantLicense } from '../../api/adminPaymentsApi'

export default function LicenseGrantModal({ show, offer, onClose, onGranted }) {
  const [scopeModel, setScopeModel] = useState('User')
  const [scopeId, setScopeId] = useState('')
  const [reason, setReason] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    const scopes = offer?.licenseScopes || []
    setScopeModel(scopes.includes('User') ? 'User' : scopes.includes('Office') ? 'Office' : 'User')
    setScopeId('')
    setReason('')
    setError('')
  }, [offer?._id, show])

  const handleGrant = async () => {
    if (!offer?._id || !scopeId.trim()) {
      setError('Укажи цифровое предложение и ID получателя.')
      return
    }
    setSaving(true)
    setError('')
    try {
      const result = await grantLicense({
        offerId: offer._id,
        scopeModel,
        scopeId: scopeId.trim(),
        reason: reason.trim(),
      })
      onGranted?.(result)
    } catch (err) {
      setError(getApiErrorMessage(err, 'Не удалось выдать лицензию'))
    } finally {
      setSaving(false)
    }
  }

  const scopes = offer?.licenseScopes || ['User', 'Office']

  return (
    <Modal show={show} handleClose={onClose} modalTitle="Выдать цифровую лицензию" size="md">
      <div className="admin-payments__grant-modal">
        <div className="admin-payments__info-note">
          <b>{offer?.title || offer?.code || 'Выбери предложение'}</b><br />
          Ручная выдача создаёт ADMIN-лицензию за 0 ₽ и не рисует банковский платёж или движение баланса.
        </div>
        <label>
          <span>Кому</span>
          <select value={scopeModel} onChange={(e) => setScopeModel(e.target.value)}>
            {scopes.includes('User') ? <option value="User">Пользователю</option> : null}
            {scopes.includes('Office') ? <option value="Office">Офису</option> : null}
          </select>
        </label>
        <label>
          <span>{scopeModel === 'User' ? 'User ID' : 'Office ID'}</span>
          <input value={scopeId} onChange={(e) => setScopeId(e.target.value)} placeholder="Mongo ObjectId" />
        </label>
        <label>
          <span>Причина</span>
          <textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Бонус, компенсация, ручная выдача…" />
        </label>
        {error ? <div className="admin-payments__error">{error}</div> : null}
        <div className="admin-payments__modal-actions">
          <button type="button" onClick={onClose}>Отмена</button>
          <button type="button" className="admin-payments__primary" disabled={saving || !offer} onClick={handleGrant}>
            {saving ? 'Выдача…' : 'Выдать лицензию'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
